var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQMarkHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 267.18966 267.18964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4579bd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    className: "cls-1",
    d: "M261.26905,507.269h26.719V480.55h-26.719Zm13.35947-213.75171a133.59484,133.59484,0,1,0,51.12229,10.168A133.59482,133.59482,0,0,0,274.62852,293.51724Zm0,240.47069A106.87586,106.87586,0,1,1,381.50439,427.11208,106.87585,106.87585,0,0,1,274.62852,533.98793Zm0-187.03275a53.43792,53.43792,0,0,0-53.43793,53.43792v0h26.719a26.719,26.719,0,0,1,53.43792,0c0,26.719-40.07845,23.37909-40.07845,66.79741h26.719c0-30.05883,40.07844-33.3987,40.07844-66.79741A53.43793,53.43793,0,0,0,274.62852,346.95518Z",
    transform: "translate(-141.03448 -293.51724)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQMarkHover);
export default __webpack_public_path__ + "static/media/QMarkHover.915f1a522d9eb32f9d95ac78486fa8c1.svg";
export { ForwardRef as ReactComponent };